
<v-tooltip>
    <template v-slot:activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on" class="lgs-status" :class="statusColor"></div>
    </template>
    <span>{{ $t('enums.unitStateTypes.' + stateId) }}</span>
</v-tooltip>
